import  { Resource } from "./Resource";
import  { LogGroup , Log ,MyPIXIContainer } from ".././MyHelpers";
import  { ResourceIdentifier } from "./ResourceIdentifier";
import  { ImageResource } from "./ImageResource";
import  { JSONResource } from "./JSONResource";
import  { Sprite } from "../slot/Sprite/Sprite"



export class SpriteResource extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "sprite";
	}

	protected resid: ResourceIdentifier = null;
	protected logGroup: LogGroup = null;

	public imageResource: ImageResource = null;
	protected imageLoaded: "notloaded" | "success" | "error" = "notloaded";

	public jsonResource: JSONResource = null;
	protected jsonLoaded: "notloaded" | "success" | "error" = "notloaded";

	//protected anyLoadError: boolean = false;


	//protected additionalProperties: SpriteAdditionalProperties = null;
	protected decodeOnLoad: boolean = false;

	// always make a copy of sprite, not to interfere with playing
	// note - copy creates shallow copy, only the sprite state, but the image data is shared
	protected _sprite: Sprite = null;
	public get sprite(): Sprite
	{
		return this._sprite.Copy();
	}

	protected decodeStartTime: number = 0;

	protected static readonly ImageExtension = ".png";
	protected static readonly JsonExtension = ".json";

	public constructor(path: string, resid: ResourceIdentifier, required: boolean = true, logGroup: LogGroup = null, decodeOnLoad: boolean = false)
	{
		super(path, resid.ID(), required);

		this.resid = resid;
		this.logGroup = logGroup;

		this.imageResource = new ImageResource(path + SpriteResource.ImageExtension, this.resid.Add("img").ID(), required);
		this.jsonResource  = new JSONResource(path + SpriteResource.JsonExtension, this.resid.Add("json").ID(), required);

		this.decodeOnLoad = decodeOnLoad;

		this.imageResource.AddOnLoadedCallback(() => {
			this.imageLoaded = "success";
			if (this.jsonLoaded == "success")
			{
				this.Decode();
			}
		});

		this.jsonResource.AddOnLoadedCallback(() => {
			this.jsonLoaded = "success";
			if (this.imageLoaded == "success")
			{
				this.Decode();
			}
		});

		this.imageResource.AddOnLoadErrorCallback(() => {
			this.imageLoaded = "error";
			if (this.jsonLoaded != "notloaded")
			{
				this.LoadError()
			}
		});

		this.jsonResource.AddOnLoadErrorCallback(() => {
			this.jsonLoaded = "error";
			if (this.imageLoaded != "notloaded")
			{
				this.LoadError()
			}
		});
	}

	protected Decode(): void
	{
		try
		{
			this._sprite = Sprite.Create(this.imageResource.img, this.jsonResource.json, this.path, this.resid, this.logGroup);

			if (this.decodeOnLoad)
			{
				this._sprite.AddOnDecodedCallbackSingleShot(() => {
					this.Loaded();
				});

				this._sprite.Decode();
			}
			else
			{
				this.Loaded();
			}
		}
		catch (ex)
		{
			this.LoadError();
		}
	}

	public Load(prevenCache: boolean = false): void {
		// this.imageLoaded = "notloaded";
		// this.imageLoaded = "notloaded";

		this.imageResource.Load(prevenCache);
		this.jsonResource.Load(prevenCache);
	}

	public override Reload(preventCache: boolean = false): void {
		this.imageLoaded = "notloaded";
		this.jsonLoaded = "notloaded";

		this.imageResource.Reload(preventCache);
		this.jsonResource.Reload(preventCache);
	}

	public override GetPaths(): string[]
	{
		return [
			this.path + SpriteResource.ImageExtension,
			this.path + SpriteResource.JsonExtension,
			...this.altPaths
		]
	}
}